import { QUOTE_SCOPE } from "@msys/textutils";
import { AvailableReplacementsModal } from "../../documents/AvailableReplacementsModal.js";

export function AvailableContractingPdfReplacementsModal({
  handleClose,
}: {
  handleClose(): void;
}) {
  return (
    <AvailableReplacementsModal scope={QUOTE_SCOPE} handleClose={handleClose} />
  );
}
